export default [
    {
        path: '/client-settings/:filter?',
        name: 'client_settings',
        component: () => import('@src/client-settings/client-settings'),
        meta: {
            title: 'Geräteeinstellungen',
            role: 'ROLE_LIST_CLIENT_SETTINGS',
        },
    },
    {
        path: '/client-settings/create',
        name: 'client_settings_create',
        component: () => import('@src/client-settings/client-settings-create'),
        meta: {
            title: 'Gerät erstellen',
            role: 'ROLE_EDIT_CLIENT_SETTINGS',
        },
    },
    {
        path: '/client-settings/edit/:id',
        name: 'client_settings_edit',
        props(route) {
            return { ...route.params };
        },
        component: () => import('@src/client-settings/client-settings-edit'),
        meta: {
            role: 'ROLE_EDIT_CLIENT_SETTINGS',
        },
    },
];
